import { teachurKeys as i } from "../../constants/teachurKeys.js";
const d = (s, t, f, p, a) => {
  const l = p ? s.getQueryData(
    i.lessons.objectives(p)
  ) : void 0, b = a ? s.getQueryData(i.courses.completion(a)) : void 0, Q = a ? s.getQueryData(i.courses.lessons(a)) : void 0, g = s.getQueryData(i.users.currentUser()), D = a ? s.getQueryData(i.courses.detail(a)) : void 0, O = s.getQueryData(
    i.courses.list()
  );
  return p && l && s.setQueryData(
    i.lessons.objectives(p),
    (e) => e && e.map(
      (r) => r.id === t ? {
        ...r,
        isCompleted: !f,
        completedAt: f ? void 0 : /* @__PURE__ */ new Date()
      } : r
    )
  ), a && s.setQueryData(i.courses.lessons(a), (e) => e && e.map((r) => {
    var c, m;
    if (r.id !== p) return r;
    const n = r.totalObjectives ?? ((c = r.objectiveIds) == null ? void 0 : c.length) ?? 0;
    let u;
    if (f)
      u = (r.completedObjectiveIds ?? []).filter(
        (j) => j !== t
      );
    else {
      if ((m = r.completedObjectiveIds) != null && m.includes(t)) return r;
      u = [...r.completedObjectiveIds ?? [], t];
    }
    const o = u.length, v = n > 0 ? Math.round(o / n * 100) : 0;
    return {
      ...r,
      completedObjectives: o,
      completedObjectiveIds: u,
      progress: v
    };
  })), g && s.setQueryData(i.users.currentUser(), (e) => {
    var n;
    return e && (f ? {
      ...e,
      completedObjectives: (e.completedObjectives ?? []).filter(
        (u) => u.id !== t
      )
    } : ((n = e.completedObjectives) == null ? void 0 : n.some((u) => u.id === t)) ? e : {
      ...e,
      completedObjectives: [
        ...e.completedObjectives ?? [],
        { id: t }
      ]
    });
  }), a && D && s.setQueryData(
    i.courses.detail(a),
    (e) => {
      if (!e) return e;
      const r = s.getQueryData(i.courses.lessons(a)) ?? [], n = r.reduce(
        (v, c) => {
          var m;
          return v + (c.totalObjectives ?? ((m = c.objectiveIds) == null ? void 0 : m.length) ?? 0);
        },
        0
      ), u = r.reduce(
        (v, c) => {
          var m;
          return v + (((m = c.completedObjectiveIds) == null ? void 0 : m.length) ?? 0);
        },
        0
      ), o = n > 0 ? Math.round(u / n * 100) : e.selfAssessmentCompletionPercentage;
      return { ...e, selfAssessmentCompletionPercentage: o };
    }
  ), a && O && s.setQueryData(
    i.courses.list(),
    (e) => {
      if (!e) return e;
      const r = s.getQueryData(i.courses.lessons(a)) ?? [], n = r.reduce(
        (o, v) => {
          var c;
          return o + (v.totalObjectives ?? ((c = v.objectiveIds) == null ? void 0 : c.length) ?? 0);
        },
        0
      ), u = r.reduce(
        (o, v) => {
          var c;
          return o + (((c = v.completedObjectiveIds) == null ? void 0 : c.length) ?? 0);
        },
        0
      );
      return {
        ...e,
        data: e.data.map(
          (o) => o.id === a ? {
            ...o,
            selfAssessmentCompletionPercentage: n > 0 ? Math.round(u / n * 100) : o.selfAssessmentCompletionPercentage
          } : o
        )
      };
    }
  ), {
    previousObjectives: l,
    previousCompletion: b,
    previousLessons: Q,
    previousCurrentUser: g,
    previousCourseDetail: D,
    previousCoursesList: O
  };
}, y = (s, t, f, p) => {
  f && t.previousObjectives && s.setQueryData(
    i.lessons.objectives(f),
    t.previousObjectives
  ), p && t.previousCompletion && s.setQueryData(
    i.courses.completion(p),
    t.previousCompletion
  ), p && t.previousLessons && s.setQueryData(i.courses.lessons(p), t.previousLessons), t.previousCurrentUser && s.setQueryData(i.users.currentUser(), t.previousCurrentUser), p && t.previousCourseDetail && s.setQueryData(
    i.courses.detail(p),
    t.previousCourseDetail
  ), t.previousCoursesList && s.setQueryData(i.courses.list(), t.previousCoursesList);
};
export {
  y as rollbackMarkObjectiveCompleted,
  d as toggleObjectiveOptimistically
};
